export const DateType = {
  Days: 'Days',
  Weeks: 'Weeks',
  Months: 'Months',
  Years: 'Years'
};
